import React, {Component} from 'react';
class PmStatusIcon extends Component {
    render() {
        const conv = this.props.conversation;
        let renderUnread = 
            conv.unreadCount > 0 ||
            conv.generalStatus == 'requested_by_me' ||
            conv.generalStatus == 'requested_by_recipient';

        let unreadClasses = ['unread-indicator'];
        let unreadText = "?";
        if (conv.generalStatus == 'requested_by_me' ||
            conv.generalStatus == 'requested_by_recipient') {
            unreadText = "?";
            unreadClasses.push("request");
        } else {
            unreadText = conv.unreadCount;
            unreadClasses.push("messages");
        }

        let unreadClass = unreadClasses.join(' ');

        return renderUnread ? <span className={unreadClass}>{unreadText}</span> : null;
    }
}

export default PmStatusIcon;


// WEBPACK FOOTER //
// ./src/components/pm/PmStatusIcon.js